import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { UserService } from '../shared/services/user.service';
import { urls } from '../shared/constants';
import { UserRole } from '#backend/common/user-types';

export const hasOrgGuard: CanActivateFn = async () => {
  // Skip guard if debug flag is enabled
  if (environment.skipAuth) {
    return true;
  }

  const userService = inject(UserService);
  const router = inject(Router);

  try {
    const user = await userService.requireUser();

    // Usuários Geoambiente são redirecionados para o painel de clientes ou monitoramento
    if (user.organizationId == null) {
      // verifica papel para evitar loop infinito
      if (user.role === UserRole.ADMIN_GEOAMBIENTE) {
        router.navigate([urls.internalDashboard], { replaceUrl: true });
      } else {
        router.navigateByUrl('monitoring-safras', { replaceUrl: true });
      }

      return false;
    }

    return true;
  } catch (error) {
    console.error('[HasOrgGuard] Falha ao carregar usuário', error);
    router.navigate([urls.login]);
    return false;
  }
};
